exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loader{display:-ms-flexbox;display:flex;min-height:180px;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%\n}\n.accessible-checkbox{margin:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end\n}\n", ""]);

// exports
